import Button from "@mui/material/Button";
import React, { FC } from "react";
import { connect, ConnectedProps } from "react-redux";
import { setUserAction } from "../../redux/actions";
import { useMsal } from "@azure/msal-react";

const mapDispatchToProps = { setUser: setUserAction };

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux;
const connector = connect(null, mapDispatchToProps);

const LogoutButton: FC<Props> = ({ setUser }) => {
	const { instance, accounts } = useMsal();

	const handleLogoutButtonClick = () => {
		instance.logoutPopup().catch((e) => console.error(e));
	};

	return (
		<Button
			variant="contained"
			color="secondary"
			onClick={handleLogoutButtonClick}
		>
			Log out
		</Button>
	);
};

export default connector(LogoutButton);
